/**
 * Abbreviations
 *
 * c_psd -> cached partial startup data
 *       -> 0: not cached | 1: valid cache
 * c_em  -> cached emails
 *       -> 0: not cached | 1: valid cache
 */
type DiagnosticsKeys = 'c_psd' | 'c_em';
type BootstrapPerformanceDiagnostics = Record<DiagnosticsKeys, any>;

const bootstrapPerformanceDiagnostics: Partial<BootstrapPerformanceDiagnostics> = {};

export const addBootstrapPerformanceDiagnostics = (key: DiagnosticsKeys, value: any) => {
    bootstrapPerformanceDiagnostics[key] = value;
};

export const getBootstrapPerformanceDiagnostics = () => bootstrapPerformanceDiagnostics;
